module.exports = __webpack_public_path__ + "img/24600.302dd86b.jpg";